/**
 * Cast a function to a jest mocked function
 *
 * @example
 *
 * import { Test } from '@catawiki/runtime-toolkit';
 *
 * const mockedFunction = Test.castFnToMocked(jest.fn(() => 'test'));
 * const result = mockedFunction();
 *
 * expect(mockedFunction).toBeCalled();
 * expect(result).toBe('test');
 * expect(mockedFunction).toHaveReturnedWith('test');
 *
 */
export const castFnToMocked = (fn) => fn;
